export class PurchaseOrderFilter {
  id: string;
  name: string;
  loading: boolean;
  selected: boolean;
  classes: string;

  constructor() { }
}
